import request from './request'

// 安心保派遣单位列表-分页查询 insureType 2：长期保 8：安心日保
export function queryPageListApi(data: {insureType?:number; serveCompanyName: string; pageSize: number; pageNum: number }): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodServeCompany/queryPageList', { params: data })
}

// 根据安心保派遣单位id删除安心保派遣单位
export function deleteByPeriodServeCompanyIdApi(id: number | string): Promise<any> {
  return request.delete(`/isNew---/web/pc/pay/insurePeriodServeCompany/deleteByPeriodServeCompanyId/${id}`)
}

// 撤销工种申请
export function revokeOccupationApplyApi(data: { occupationRecordId: number | string }): Promise<any> {
  return request.put(`/isNew---/web/pc/pay/insurePeriodServeCompany/revokeOccupationApply?occupationRecordId=${data.occupationRecordId}`)
}

// 根据id查询安心保派遣单位信息
export function queryByIdApi(id: number | string): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insurePeriodServeCompany/queryById/${id}`)
}

// 工种记录
export function queryOccupationRecordApi(data: { periodServeCompanyId: number | string; queryMonth?: string }): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodServeCompany/queryOccupationRecord', { params: data })
}

// 可用工种查询
export function queryAvailableOccupationApi(id: number | string): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insurePeriodServeCompany/queryAvailableOccupation/${id}`)
}

// 申请新工种
export function applyOccupationApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodServeCompany/applyOccupation', { ...data })
}

// 重新申请工种
export function reApplyOccupationApi(data: any): Promise<any> {
  return request.put('/isNew---/web/pc/pay/insurePeriodServeCompany/reApplyOccupation', { ...data })
}

// 新增投保企业并申请工种
export function addPeriodServeCompanyAndApplyOccupationApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodServeCompany/addPeriodServeCompanyAndApplyOccupation', { ...data })
}

// 查询员工列表-分页查询
export function queryStaffListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryStaffList', { params: data })
}

// 导出员工列表
export function exportStaffListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/exportStaffList', { params: data })
}

// 查询员工投保记录列表-分页查询
export function queryRecordPageListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryStaffRecordPageByByPlan', { params: data })
}
// 查询员工投保记录列表-分页查询
export function queryPeoplePageListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryRecordPageList', { params: data })
}

// 查询员工投保记录列表-分页查询
export function insurePeriodStaffRecordQueryListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryList', { params: data })
}

export function queryOutDangerStaffList(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryOutDangerStaffList', { params: data })
}


// 查询在保人数列表-分页查询
export function queryStaffNumPageListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryStaffNumPageList', { params: data })
}

// 导出在保人数列表
export function exportStaffNumListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/exportStaffNumList', { params: data })
}

// 查询投保人员统计-维度 工种、派遣单位
export function queryStatisticsApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryStatistics', { params: data })
}

// 查询安心保报案列表 保险产品（2:长期保 8:安心日保）
export function insurePeriodReportCaseListApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodReportCase/list', { params: data })
}

// 新增在线报案
export function addReportCaseApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodReportCase/addReportCase', data)
}

// 新增在线报案
export function outDangerDetailApi(data: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insurePeriodReportCase/outDangerDetail/${data.id}`)
}

// 出险详情（按 reportNo 查询）
export function outDangerDetailByIdApi(reportNo: string): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insurePeriodReportCase/outDangerDetailById/${reportNo}`)
}

// 我的方案列表（包含当前在保人数）
// 包含保司logo
export function insureEnsurePlanApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insureEnsurePlan/list', { params: data })
}

// 投保方案头部信息详情
export function insureEnsurePlanDetailApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insureEnsurePlan/detail', { params: data })
}

// 方案详情查询加减记录列表-分页查询
export function queryPageListByPlanApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodOperateRecord/queryPageListByPlan', { params: data })
}

// 导出加减记录人员名单
export function exportRecordStaffApi(id: any): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insurePeriodOperateRecord/exportRecordStaff/${id}`, {
    responseType: 'blob'
  })
}

// 查询投保人员统计-维度 工种、派遣单位
export function queryStatisticsDetailApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/queryStatistics', { params: data })
}

// 检查公司投保状态
export function checkCompanyInsureStatusApi(): Promise<any> {
  return request.get('/isNew---/web/pc/pay/openEnsure/checkCompanyInsureStatus')
}

// 手动录入-查询被派遣单位列表
export function queryListByEnterApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodServeCompany/queryListByEnter', { params: data })
}

// 检查员工是否在保-确认减保前调用
export function checkStaffInsureApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodStaffRecord/checkStaffInsure', data)
}

// 加保接口
export function insurePeriodStaffRecordApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodStaffRecord/ensure', data)
}

// 减保接口
export function teminalEnsureApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodStaffRecord/teminalEnsure', data)
}

// 换厂操作
export function modifyServeCompanyApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodStaffRecord/modifyServeCompany', data)
}

// 撤销投保（当前只能撤销灵活投保）
export function revokeEnsureApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodOperateRecord/revokeEnsure', data)
}
// 查看当前用户是否需要读取对应保司的方案条款
export function getPlanIsRead(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/crm/insureProgramTerms/getIsRead',{ params: data })
}

// 查看当前用户是否需要读取对应保司的方案条款
export function getPlanListData(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/crm/insureProgramTerms/getProgramTerms',{ params: data })
}
// 检测是否月底
export function onekeyRenewalMonthNotifyApi(data: any): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/onekeyRenewalMonthNotify', {
    params: data
  })
}
// 新增方案条款读取记录
export function addReadRecord(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/crm/insureProgramTerms/addReadRecord',data)
}
// 加保前校验
export function ensureBeforeCheckApi(data: any): Promise<any> {
  return request.post('/isNew---/web/pc/pay/insurePeriodStaffRecord/ensureBeforeCheck', data)
}


// 查询公司理赔率
export function queryInsureCompanyRateStatus(params: {
    productType: 1 | 2 | 8 // 1 日日保 2 安心保
}): Promise<any> {
  return request.get(`/isNew---/web/pc/pay/insuranceCompanyRate/queryInsureCompanyRateStatus`, {
    params
  })
}

// 安心保获取未来三天保费数据及是否弹框
export function checkCompanyBalance(): Promise<any> {
  return request.get('/isNew---/web/pc/pay/insurePeriodStaffRecord/checkCompanyBalance')
}
